var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90654 17.0294H15.057V11.9726H9.90654V17.0294ZM14.0269 0.847656V2.87038H5.78619V0.847656H3.72601V2.87038H2.69592C1.55252 2.87038 0.635742 3.77049 0.635742 4.8931V19.0521C0.635742 20.1697 1.55767 21.0749 2.69592 21.0749H17.1172C18.2554 21.0749 19.1773 20.1697 19.1773 19.0521V4.8931C19.1773 3.77049 18.2503 2.87038 17.1172 2.87038H16.0871V0.847656H14.0269ZM17.1172 19.0521H2.69592V7.92718H17.1172V19.0521Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMenu);
export default __webpack_public_path__ + "static/media/calendar_menu.520ff9efcaeb61e6aec715accdbb48e8.svg";
export { ForwardRef as ReactComponent };